export const centeredPointsOnLine = (apiClient) => {
    return {
        build(params) {
            return apiClient.request('/standard/centeredPointsOnLine', params);
        },
    };
};
